jQuery(document).ready(function() {
	$(".login_button").prop("disabled", true);
	$(".login_button").css("opacity",".5");
	$(".login_button").css("pointer-events","none");
});


jQuery(function() {
	$("[name=email]")
		.on('input', function(e) {
			const $form = $(this).closest($(".js_pwForm"));
			const $email = $form.find($("[name=email]")).val();
			const $pas = $form.find($("[name=password]")).val();
			const $loginbtn = $form.find($(".login_button"));

			if($email == "" || $pas == "") {
				$loginbtn.prop("disabled", true);
				$loginbtn.css("opacity",".5");
				$loginbtn.css("pointer-events","none");
			} else {
				$loginbtn.prop("disabled", false);
				$loginbtn.css("opacity","1");
				$loginbtn.css("pointer-events","");
			}
		});
});

jQuery(function() {
	$("[name=password]")
		.on('input', function(e) {
			const $form = $(this).closest($(".js_pwForm"));
			const $email = $form.find($("[name=email]")).val();
			const $pas = $form.find($("[name=password]")).val();
			const $loginbtn = $form.find($(".login_button"));

			if($email == "" || $pas == "") {
				$loginbtn.prop("disabled", true);
				$loginbtn.css("opacity",".5");
				$loginbtn.css("pointer-events","none");
			} else {
				$loginbtn.prop("disabled", false);
				$loginbtn.css("opacity","1");
				$loginbtn.css("pointer-events","");
			}
		});
});
